module.exports = __webpack_public_path__ + "static/media/marker_Weather.0e7e1fdc.png";